var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _class2, _descriptor3, _descriptor4, _descriptor5, _dec6, _dec7, _dec8, _dec9, _class3, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "./Decorators/primitiveTrait";
import objectTrait from "./Decorators/objectTrait";
import ModelTraits from "./ModelTraits";
import LatLonHeightTraits from "./TraitsClasses/LatLonHeightTraits";
import HeadingPitchRollTraits from "./TraitsClasses/HeadingPitchRollTraits";
export let CornerPointsStyleTraits = (_dec = primitiveTrait({
  type: "number",
  name: "Pixel size",
  description: "Pixel size of the corner point"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Color",
  description: "Corner point color. Can be any valid CSS color string."
}), _class = class CornerPointsStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "pixelSize", _descriptor, this);
    _initializerDefineProperty(this, "color", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "pixelSize", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let BoxSizeTraits = (_dec3 = primitiveTrait({
  type: "string",
  name: "Length",
  description: "Length of the box"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Length",
  description: "Length of the box"
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Length",
  description: "Length of the box"
}), _class2 = class BoxSizeTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "length", _descriptor3, this);
    _initializerDefineProperty(this, "width", _descriptor4, this);
    _initializerDefineProperty(this, "height", _descriptor5, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "length", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "width", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "height", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let BoxDrawingTraits = (_dec6 = objectTrait({
  type: LatLonHeightTraits,
  name: "Box position",
  description: "Latitude, longitude and height of the box in degrees"
}), _dec7 = objectTrait({
  type: BoxSizeTraits,
  name: "Box dimension",
  description: "Length, width and height of the box"
}), _dec8 = objectTrait({
  type: HeadingPitchRollTraits,
  name: "Rotation",
  description: "Rotation specified as heading, pitch and roll in degrees."
}), _dec9 = objectTrait({
  type: CornerPointsStyleTraits,
  name: "Corner points styling",
  description: "Corner points styling"
}), _class3 = class BoxDrawingTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "position", _descriptor6, this);
    _initializerDefineProperty(this, "size", _descriptor7, this);
    _initializerDefineProperty(this, "rotation", _descriptor8, this);
    _initializerDefineProperty(this, "cornerPointsStyle", _descriptor9, this);
  }
}, _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "position", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "size", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "rotation", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "cornerPointsStyle", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { BoxDrawingTraits as default };